var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_412_369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.74991 1.90526C-0.450426 4.19076 -9.30503e-05 6.6186 -9.30503e-05 13.9943C-9.30503e-05 20.1193 -1.06876 26.2594 4.52424 27.7049C6.27074 28.1541 21.7454 28.1541 23.4896 27.7026C25.8182 27.1018 27.7129 25.2129 27.9719 21.9194C28.0081 21.4598 28.0081 6.53693 27.9707 6.06793C27.6954 2.55976 25.5359 0.537928 22.6904 0.128428C22.0382 0.0339282 21.9076 0.00592816 18.5616 9.48198e-05C6.69307 0.00592816 4.09141 -0.522572 1.74991 1.90526Z",
    fill: "url(#paint0_linear_412_369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9978 3.66208C9.76161 3.66208 5.73894 3.28524 4.20244 7.22858C3.56778 8.85724 3.65994 10.9724 3.65994 14.0011C3.65994 16.6587 3.57478 19.1566 4.20244 20.7724C5.73544 24.7181 9.79078 24.3401 13.9954 24.3401C18.0519 24.3401 22.2344 24.7624 23.7896 20.7724C24.4254 19.1274 24.3321 17.0437 24.3321 14.0011C24.3321 9.96208 24.5549 7.35458 22.5961 5.39691C20.6128 3.41358 17.9306 3.66208 13.9931 3.66208H13.9978ZM13.0714 5.52524C21.9078 5.51124 23.0324 4.52891 22.4118 18.1754C22.1913 23.0019 18.5163 22.4722 13.9989 22.4722C5.76227 22.4722 5.52544 22.2366 5.52544 13.9964C5.52544 5.66058 6.17878 5.52991 13.0714 5.52291V5.52524ZM19.5161 7.24141C18.8313 7.24141 18.2759 7.79674 18.2759 8.48158C18.2759 9.16641 18.8313 9.72175 19.5161 9.72175C20.2009 9.72175 20.7563 9.16641 20.7563 8.48158C20.7563 7.79674 20.2009 7.24141 19.5161 7.24141ZM13.9978 8.69158C11.0659 8.69158 8.68944 11.0692 8.68944 14.0011C8.68944 16.9329 11.0659 19.3094 13.9978 19.3094C16.9296 19.3094 19.3049 16.9329 19.3049 14.0011C19.3049 11.0692 16.9296 8.69158 13.9978 8.69158ZM13.9978 10.5547C18.5536 10.5547 18.5594 17.4474 13.9978 17.4474C9.44311 17.4474 9.43611 10.5547 13.9978 10.5547Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_412_369",
    x1: 1.8036,
    y1: 26.2117,
    x2: 27.8266,
    y2: 3.68907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_412_369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic_instagram.fa281a362ab2842e631f6701be3ca8d1.svg";
export { ForwardRef as ReactComponent };